import React from 'react';

import RegionalOrganizationText from './RegionalOrganizationText';
import RegionalOrganizationList from './RegionalOrganizationList';

class RegionalOrganization extends React.Component {
  render() {
    return (
      <div>
        <div>
          <RegionalOrganizationText />
        </div>
        <div className="panel panel-default diversion-panel">
          <div className="panel-heading">
            <h3 style={{ display: 'inline' }}>Regional organizations' statements, reports and information</h3>
          </div>
          <div className="panel-body">
            <RegionalOrganizationList/>
          </div>
        </div>
      </div>
    );
  }
}

export default RegionalOrganization;



// WEBPACK FOOTER //
// ./src/components/RegionalOrganization/RegionalOrganization.js